import styled from 'styled-components';
const percentageSize = 1.3;

export const ArbreContainer = styled.div`
  height: 100%;
  width: 100%;
  padding-left: ${({ indent, hasRules }) => (hasRules ? indent * 20 : indent * 20 + 23)}px;
  box-sizing: border-box;

  @media screen and (max-width: 464px) {
    padding-left: ${({ indent, hasRules }) => (hasRules ? indent * 25 : indent * 25 + 32)}px;
  }
`;

export const LayerWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: center;
  box-sizing: border-box;

  @media screen and (max-width: 464px) {
    padding-bottom: 10px;
  }
`;

export const ExpandShrinkButton = styled.button`
  background: transparent;
  color: white;
  opacity: 90%;
  border-radius: 50%;
  border: 0;
  box-sizing: border-box;
  padding: 0px;
  margin-top: 1px;
  margin-right: 3px;

  @media screen and (max-width: 464px) {
    padding-right: 10px;
  }
`;

export const ExpandButtonIcon = styled.img`
  width: 1.1em;
  height: 1.1em;
  margin-top: 4px;
  vertical-align: top;
`;

export const ShrinkButtonIcon = styled.img`
  width: 1.1em;
  height: 1.1em;
  margin-top: 4px;
  vertical-align: top;
`;

export const LayerTitle = styled.div`
  text-decoration: none;
  color: ${({ allChecked, checked }) => (checked ? '#febf00' : allChecked ? '#febf00' : 'white')};
  width: 80%;
  margin-top: 1px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;

  @media screen and (max-width: 768px) {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  @media screen and (max-width: 464px) {
    padding-left: 15px;
  }
`;

export const LayerCheckbox = styled.input`
  opacity: 90%;
  appearance: none;
  font: inherit;
  color: white;
  width: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  height: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  margin-right: 3px;
  margin-top: 5px;
  border: ${({ checked }) => (checked ? '0.13em solid #febf00' : '0.13em solid white')};
  border-radius: 0.15em;
  display: grid;
  place-content: center;
  display: inline-block;
  position: relative;

  :hover {
    box-shadow: 0 0px 7px #febf00dd;
  }

  :checked {
    position: relative;
    width: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
    height: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
    background-image: url(${({ img }) => img});
    background-repeat: no-repeat;
    background-size: contain;
    border-radius: 0.15em;
    transition: 0.3s;
  }
`;

export const LayerRules = styled.div`
  display: inline-flex;
  align-items: flex-start;
`;

export const LayerArbreIcon = styled.div`
  @media screen and (max-width: 464px) {
    margin-left: ${({ isParent }) => (isParent ? null : '15px')};
  }
`;

export const LayerInfo = styled.div`
  display: flex;
  margin-left: 67px;
  margin-bottom: 10px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  flex-direction: column;
`;

export const LayerDescription = styled.div`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
`;

export const IconStyles = styled.div`
  background-color: ${({ color }) => color};
  border: ${({ border }) => (border !== undefined ? '1px solid ' + border : 'none')};
  height: ${({ width }) => (width !== undefined ? width : 15 + 'px')};
  width: ${({ width }) => (width !== undefined ? width : 15 + 'px')};
  background-image: ${({ img }) => (img !== undefined ? 'url(' + img + ')' : 'none')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-left: 5px;
  background-size: contain;
  border-radius: ${({ type }) => (type === 'polygon' ? 6 + 'px' : 50 + '%')};
  vertical-align: middle;
  stroke-dasharray: ${({ sdasharray }) => (sdasharray !== undefined ? sdasharray : 'none')};
`;

export const SymbolSVG = styled.svg`
  display: block;
  margin-right: 5px;
  @media screen and (max-width: 464px) {
    /* margin-left: 15px; */
  }
`;

export const PointStyle = styled.div`
  background-color: ${({ color }) => color};
  border: ${({ border }) => (border !== undefined ? border : 'none')};
  border-width: ${({ strokeWidth }) => (strokeWidth !== undefined ? strokeWidth : 'none')};
  height: ${({ width }) => (width !== undefined ? width + 'px' : 15 + 'px')};
  width: ${({ width }) => (width !== undefined ? width + 'px' : 15 + 'px')};
  background-image: ${({ img }) => (img !== undefined ? 'url(' + img + ')' : 'none')};
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-left: 5px;
  border-radius: ${({ type }) => (type === 'polygon' ? 6 + 'px' : 50 + '%')};
  vertical-align: middle;
  .triangle {
    width: 0;
    height: 0;
    border-left: 50px solid transparent;
    border-right: 50px solid transparent;
    border-bottom: 100px solid red;
  }
`;

export const RuleName = styled.div`
  display: inline-flex;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  width: 90%;
  vertical-align: middle;
`;

export const LineIcon = styled.svg`
  height: 20px;
  width: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  @media screen and (max-width: 464px) {
    /* margin-left: 15px; */
  }
`;

export const ExpandButton = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 20 * percentageSize : 20,
  height: props.fontSizeEnabled ? 20 * percentageSize : 20,
  fill: 'white'
}))`
  margin-bottom: 3px;

  :hover {
    box-shadow: 0 0px 7px #febf00dd;
    border-radius: 50%;
  }
`;

export const ShrinkButton = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 20 * percentageSize : 20,
  height: props.fontSizeEnabled ? 20 * percentageSize : 20,
  fill: 'white'
}))`
  margin-bottom: 3px;

  :hover {
    box-shadow: 0 0px 7px #febf00dd;
    border-radius: 50%;
  }
`;
export const IconWrapper = styled.div`
  margin-right: 5px;
  background-image: url(${({ backgroundImage }) => (backgroundImage !== '' ? backgroundImage : 'none')});
  text-align: center;
  width: 20px;
  height: 20px;

  @media screen and (max-width: 464px) {
    margin-left: 15px;
  }
`;

export const ArbreCapesSVG = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 16 * percentageSize : 16,
  height: props.fontSizeEnabled ? 16 * percentageSize : 16
}))``;
